import React, { useEffect, useRef } from "react";

const NAMES = ["Rama,", "రామ,", "ராம,", "ರಾಮ,", "राम,", "രാമ,", "রাম,"];

const FUN_STATS = [
  { num: "3", unit: "yrs", label: "of shipping code" },
  { num: "∞", unit: "", label: "bugs debugged" },
  { num: "1", unit: "tool", label: "built & live" },
  { num: "0", unit: "", label: "regrets about the craft" },
];

const Hero = () => {
  const typedRef = useRef(null);
  const state = useRef({ ni: 0, ci: 0, del: false });

  useEffect(() => {
    let timer;
    const tick = () => {
      const { ni, ci, del } = state.current;
      const name = NAMES[ni];
      if (!del) {
        const next = ci + 1;
        if (typedRef.current)
          typedRef.current.textContent = name.slice(0, next);
        state.current.ci = next;
        if (next === name.length) {
          state.current.del = true;
          timer = setTimeout(tick, 1200);
          return;
        }
      } else {
        const next = ci - 1;
        if (typedRef.current)
          typedRef.current.textContent = name.slice(0, next);
        state.current.ci = next;
        if (next === 0) {
          state.current.del = false;
          state.current.ni = (ni + 1) % NAMES.length;
          timer = setTimeout(tick, 400);
          return;
        }
      }
      timer = setTimeout(tick, del ? 60 : 120);
    };
    timer = setTimeout(tick, 600);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="hero" className="hero-section" style={s.hero}>
      <div style={s.gridBg} />
      <div style={s.glow} />
      <div style={s.content}>
        <h1 style={s.name}>
          Ramakrishna
          <br />
          <em style={s.nameEm}>Katragadda.</em>
        </h1>

        <p style={s.typingLine}>
          Hi, I'm&nbsp;
          <span ref={typedRef} style={s.typedName} />
          <span style={s.caret} />
          &nbsp;nice to meet you.
        </p>

        <p style={s.tagline}>
          <strong style={s.strong}>Software Engineer</strong> with 3 years in
          fintech, obsessed with the craft of building things that work —
          cleanly, reliably, and with intention.
          <br />
          Not just UI. <strong style={s.strong}>Engineering.</strong>
        </p>

        <div className="hero-actions">
          <a href="#projects" style={s.btnPrimary}>
            ↓ See my work
          </a>
          <a href="#contact" style={s.btnGhost}>
            Let's talk
          </a>
          <a
            href="https://github.com/ramakrishnakatragadda"
            target="_blank"
            rel="noreferrer"
            style={s.btnGhost}
          >
            GitHub ↗
          </a>
        </div>

        <div className="hero-stats-row">
          {FUN_STATS.map(({ num, unit, label }) => (
            <div key={label}>
              <div style={s.statNum}>
                {num}
                <span style={s.statUnit}>{unit}</span>
              </div>
              <div style={s.statLabel}>{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const s = {
  hero: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    maxWidth: 1100,
    margin: "0 auto",
    position: "relative",
  },
  gridBg: {
    position: "fixed",
    inset: 0,
    pointerEvents: "none",
    backgroundImage:
      "linear-gradient(rgba(192,132,252,0.04) 1px,transparent 1px),linear-gradient(90deg,rgba(192,132,252,0.04) 1px,transparent 1px)",
    backgroundSize: "60px 60px",
    WebkitMaskImage:
      "radial-gradient(ellipse 80% 80% at 50% 50%,black 20%,transparent 100%)",
    zIndex: -1,
  },
  glow: {
    position: "fixed",
    width: 600,
    height: 600,
    pointerEvents: "none",
    background:
      "radial-gradient(circle,rgba(124,58,237,0.1) 0%,transparent 70%)",
    top: "40%",
    left: "25%",
    transform: "translate(-50%,-50%)",
    zIndex: -1,
  },
  content: { position: "relative", zIndex: 1 },
  name: {
    fontFamily: "var(--serif)",
    fontSize: "clamp(2.8rem,7vw,6.5rem)",
    lineHeight: 1.05,
    color: "var(--text)",
    marginBottom: "0.25rem",
  },
  nameEm: { fontStyle: "italic", color: "var(--accent)" },
  typingLine: {
    fontSize: "clamp(0.85rem,2vw,1.05rem)",
    color: "var(--muted2)",
    marginBottom: "2rem",
    minHeight: "1.8em",
  },
  typedName: { color: "var(--accent2)", fontWeight: 500 },
  caret: {
    display: "inline-block",
    width: 2,
    height: "1em",
    background: "var(--accent)",
    verticalAlign: "text-bottom",
    animation: "blink 1s step-end infinite",
    marginLeft: 1,
  },
  tagline: {
    fontSize: "clamp(0.8rem,1.4vw,0.95rem)",
    color: "var(--muted)",
    maxWidth: 520,
    marginBottom: "2.5rem",
    lineHeight: 1.95,
    borderLeft: "1px solid var(--border2)",
    paddingLeft: "1.25rem",
  },
  strong: { color: "var(--muted2)", fontWeight: 400 },
  btnPrimary: {
    fontFamily: "var(--mono)",
    fontSize: "0.72rem",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "var(--bg)",
    background: "var(--accent)",
    border: "none",
    padding: "11px 22px",
    borderRadius: "var(--radius)",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
  },
  btnGhost: {
    fontFamily: "var(--mono)",
    fontSize: "0.72rem",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "var(--muted2)",
    background: "transparent",
    border: "1px solid var(--border2)",
    padding: "11px 22px",
    borderRadius: "var(--radius)",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
  },
  statNum: {
    fontSize: "1.5rem",
    fontWeight: 500,
    color: "var(--text)",
    lineHeight: 1,
  },
  statUnit: { fontSize: "0.9rem", color: "var(--accent)", marginLeft: 2 },
  statLabel: {
    fontSize: "0.65rem",
    color: "var(--muted)",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    marginTop: 4,
  },
};

export default Hero;
